import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuex from "vuex";

Vue.use(Vuex);
Vue.use(VueAxios, axios);
const localUrl = "http://127.0.0.1:8000/";
const prodUrl = "https://api.gunspring.com/";
axios.defaults.baseURL = prodUrl;

const configs = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("access_token"),
  },
};
export default new Vuex.Store({
  state: {
    documentField: {},
    TransactionType: [],
    country: [],
    industry: [],
    apptype: [],
    businessOperate: [],
    OnlineCart: [],
    BusinessTypeChoice: [],
    BaseUSState: [],
    BusinessZoneChoice: [],
    creditCard: [],
    userapp: localStorage.getItem("user") || null,
    accessToken: localStorage.getItem("access_token") || null, // makes sure the user is logged in even after
    // refreshing the page
    refreshToken: localStorage.getItem("refresh_token") || null,
    baseApp: localStorage.getItem("base_app") || null,
    appCode: localStorage.getItem("appCode") || null,
    APIData: "",
    isadmin: localStorage.getItem("is_admin_authenticted") || null,
    messages: [],
    userMessages: [],
    unreadMessages: 0,
    appList: []
  },
  getters: {
    loggedIn(state) {
      return state.accessToken != null;
    },
    isAdmin(state) {
      return state.isadmin == "superuser";
    },
    user_app_data(state) {
      if (typeof (state.userapp) == 'string') {
        return JSON.parse(state.userapp)
      }
      return state.userapp;
    }
  },

  actions: {
    getMessageHistory(context) {

      return new Promise((resolve, reject) => {
        axios
          .get(`rocketchat/api/v1/livechat/messages.history/${this.state.userapp.uid}?token=${this.state.userapp.creator}`)
          .then((res) => {
            resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },
    setRocketChannel(context, credential) {
      return new Promise((resolve, reject) => {
        axios
          .get(`rocketchat/api/v1/livechat/room?token=${this.state.userapp.creator}&rid=${this.state.userapp.uid}`)
          .then((res) => {
            resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },
    hasApp(context, code) {
      return new Promise((resolve, reject) => {
        axios
          .get(`applications/authapp/${code}/`, configs)
          .then((res) => {
            resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },
    hasAccess(context) {
      return new Promise((resolve, reject) => {
        axios
          .get(`user-api/admin-access/`, configs)
          .then((response) => {
            resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },
    resetPassword(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`user-api/password-reset/`, {
            key: credentials.key,
            password: credentials.password,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    get_app_list({ commit }) {
      return new Promise((resolve, reject) => {
        axios
        .get(`applications/details/`, configs)
        .then((result) => {
          commit("SAVE_APP_LIST", result.data);
          resolve(result);
        })
        .catch((err) => {
          reject(err);
          throw new Error(`API ${err}`);
        });
      });
    },
    get_app_detail(context, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `applications/details/${params.key}/?appcode=${params.app}`,
            configs
          )
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    delete_app(context, appcode) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`applications/userapps/${appcode}/`, configs)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    update_app(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`applications/userapps/${data.appcode}/?users`, {
            dba: data.dba,
            completed_field: data.completed_field
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    submit_app(context, data) {
      // data.submit = 'submited' string
      return new Promise((resolve, reject) => {
        axios
          .put(`applications/userapps/${data.appcode}/?admin`, {
            submited_to_bank: data.submit
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    status_app(context, data) {
      // data.status
      // approve = 'Approved' string
      // approve = 'Rejected' string

      return new Promise((resolve, reject) => {
        axios
          .put(`applications/userapps/${data.appcode}/?admin`, {
            status: data.status,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    change_appcode(context, data) {
      context.commit("changeAppCode", data.key);
    },
    requestReset(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`user-api/request-reset/`, {
            email: credentials.email,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    emailConfirm(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`user-api/email-verify/`, {
            key: credentials.key,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    loadUserapp(context, code) {
      return new Promise((resolve, reject) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        };
        axios
          .get(`applications/userapps/${code}/`, config)
          .then((result) => {
            localStorage.removeItem('user')
            context.commit("updateUserapp", result.data);
            context.commit("userdata", result.data);
            resolve(result)
          })
          .catch((error) => {
            reject(error.response)
            throw new Error(`API ${error}`);
          });
      })
    },
    loadOnlineCart({ commit }) {
      axios
        .get("helper/requirements/?name=CartChoice&cart=false")
        .then((result) => {
          commit("SAVE_OnlineCart", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadcreditCard({ commit }) {
      axios
        .get("helper/requirements/?name=CartChoice&cart=true")
        .then((result) => {
          commit("SAVE_creditCard", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadTransactionType({ commit }) {
      axios
        .get("helper/requirements/?name=TransactionType")
        .then((result) => {
          commit("SAVE_TransactionType", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadBusinessTypeChoice({ commit }) {
      axios
        .get("helper/requirements/?name=BusinessTypeChoice")
        .then((result) => {
          commit("SAVE_BusinessTypeChoice", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadBaseUSState({ commit }) {
      axios
        .get("helper/requirements/?name=BaseUSState")
        .then((result) => {
          commit("SAVE_BaseUSState", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadBusinessZoneChoice({ commit }) {
      axios
        .get("helper/requirements/?name=BusinessZoneChoice")
        .then((result) => {
          commit("SAVE_BusinessZoneChoice", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadBusinessOperate({ commit }) {
      axios
        .get("helper/requirements/?name=BusinessOperateChoice")
        .then((result) => {
          commit("SAVE_BO", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadCountry({ commit }) {
      axios
        .get("helper/requirements/?name=BaseCountry")
        .then((result) => {
          commit("SAVE_COUNTRY", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadIndustry({ commit }) {
      axios
        .get("helper/requirements/?name=IndustryType")
        .then((result) => {
          commit("SAVE_INDUSTRY", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadApptype({ commit }) {
      axios
        .get("helper/requirements/?name=AppType")
        .then((result) => {
          commit("SAVE_APPTYPES", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadMessages({ commit }) {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      axios
        .get(`message-api/messages/`, config)
        .then((result) => {
          commit("SAVE_MESSAGES", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadUserMessages({ commit }, channel) {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      axios
        .get(`message-api/messages/?channel=${channel}`, config)
        .then((result) => {
          commit("SAVE_MESSAGES", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    loadUnreadMessages({ commit }) {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      axios
        .get(`message-api/messages/${localStorage.getItem("channel")}/`, config)
        .then((result) => {
          commit("SAVE_UNREAD_MESSAGES", result.data.unread_messages);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    readMessages({ commit }, channel) {
      var channel_id = channel ? channel : localStorage.getItem("channel");
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      axios
        .get(`message-api/messages/${channel_id}/mark_as_read/`, config)
        .then((result) => {
          commit("SAVE_UNREAD_MESSAGES", 0);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    writeMessages(context, { text, channel }) {
      var channel_id = channel ? channel : localStorage.getItem("channel");
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`message-api/messages/`, {
            text: text,
            dialog: channel_id
          }, config)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    refreshToken(context) {
      return new Promise((resolve, reject) => {
        axiosBase
          .post("user-api/token-refresh/", {
            refresh: context.state.refreshToken,
          }) // send the stored refresh token to the backend API
          .then((response) => {
            // if API sends back new access and refresh token update the store
            context.commit("updateAccess", response.data.access);
            resolve(response.data.access);
          })
          .catch((err) => {
            reject(err); // error generating new access and refresh token because refresh token has expired
          });
      });
    },
    verifyToken(context, token) {
      return new Promise((resolve, reject) => {
        axios
          .post("user-api/token-verify/", {
            token: token,
          }) // send the stored refresh token to the backend API
          .then((response) => {
            // if API sends back new access and refresh token update the store
            axios.interceptors.request.use(function (config) {
              config.headers.Authorization = `Bearer ${response.data.token}`;

              return config;
            });
            context.commit("updateLocalStorage", {
              access: response.data.token,
              refresh: response.data.token,
              baseapp: response.data.user.user_app,
              appcode: response.data.user.user_app_code,
            }); // store the access and refresh token in localstorage
            context.commit("AUTH_ADMIN", response.data.user.admin);

            resolve();
          })
          .catch((err) => {
            context.commit("destroyToken");
            reject(err); // error generating new access and refresh token because refresh token has expired
          });
      });
    },
    logoutUser(context) {
      if (context.getters.loggedIn) {
        localStorage.removeItem("fcm");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("base_app");
        localStorage.removeItem("appCode");
        context.commit("destroyToken");
      }
    },
    loginUser(context, credentials) {
      return new Promise((resolve, reject) => {
        // send the username and password to the backend API:
        axios
          .post("user-api/token-auth/", {
            email: credentials.email,
            password: credentials.password,
          })
          // if successful update local storage: > 400
          .then((response) => {
            axios.interceptors.request.use(function (config) {
              config.headers.Authorization = `Bearer ${response.data.token}`;
              return config;
            });
            context.commit("updateLocalStorage", {
              access: response.data.token,
              refresh: response.data.token,
              baseapp: response.data.user.user_app,
              appcode: response.data.user.user_app_code,
            }); // store the access and refresh token in localstorage
            context.commit("AUTH_ADMIN", response.data.user.admin); // store admin status
            localStorage.setItem("channel", response.data.user.channel);
            resolve(response.data.user.admin);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setDocument(context, obj) {

      context.commit("documentationsField", obj);

    },
    contactUs(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`message-api/send_email/`, credentials)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    sendBrokerEmail(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`applications/sendapp/`, credentials, configs)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    postJob(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`jobs/`, data, configs)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getJob(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`jobs/${data}/`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getJobAll(context) {
      return new Promise((resolve, reject) => {
        axios
          .get(`jobs/`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editJob(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`jobs/${data.job_id}/`, data, configs)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteJob(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`jobs/${data.job_id}/`, configs)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    emailJob(context, data) {
      var multipart_header = {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW"
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`jobs/email/`, data,multipart_header)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mutations: {
    AUTH_ADMIN(state, isadmin) {
      var userstatus = "";
      if (isadmin) {
        userstatus = "superuser";
        state.isadmin = "superuser"
      } else if (state.accessToken) {
        userstatus = "user";
        state.isadmin = "user"

      } else {
        state.isadmin = "anynomous"
        userstatus = "anynomous";
      }
      localStorage.setItem("is_admin_authenticted", userstatus);
    },
    SAVE_OnlineCart(state, OnlineCart) {
      state.OnlineCart = OnlineCart;
    },
    SAVE_creditCard(state, creditCard) {
      state.creditCard = creditCard;
    },
    SAVE_TransactionType(state, TransactionType) {
      state.TransactionType = TransactionType;
    },
    SAVE_COUNTRY(state, country) {
      state.country = country;
    },
    SAVE_INDUSTRY(state, industry) {
      state.industry = industry;
    },
    SAVE_APPTYPES(state, apptype) {
      state.apptype = apptype;
    },
    SAVE_MESSAGES(state, messages) {
      state.messages = messages;
    },
    SAVE_USER_MESSAGES(state, userMessages) {
      state.userMessages = userMessages;
    },
    SAVE_UNREAD_MESSAGES(state, unreadMessages) {
      state.unreadMessages = unreadMessages;
    },
    SAVE_APP_LIST(state, appList) {
      state.appList = appList;
    },
    SAVE_BO(state, businessOperate) {
      state.businessOperate = businessOperate;
    },
    SAVE_BusinessTypeChoice(state, BusinessTypeChoice) {
      state.BusinessTypeChoice = BusinessTypeChoice;
    },
    SAVE_BaseUSState(state, BaseUSState) {
      state.BaseUSState = BaseUSState;
    },

    SAVE_BusinessZoneChoice(state, BusinessZoneChoice) {
      state.BusinessZoneChoice = BusinessZoneChoice;
    },
    updateLocalStorage(state, { access, refresh, baseapp, appcode }) {
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      localStorage.setItem("base_app", baseapp);
      localStorage.setItem("appCode", appcode);
      state.appCode = appcode;
      state.baseApp = baseapp;
      state.accessToken = access;
      state.refreshToken = refresh;
    },
    updateAccess(state, access) {
      state.accessToken = access;
    },
    destroyToken(state) {
      state.isadmin = null;
      state.accessToken = null;
      state.refreshToken = null;
      localStorage.removeItem("is_admin_authenticted");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("base_app");
      localStorage.removeItem("appCode");
      localStorage.clear();
    },
    updateUserapp(state, userapp) {
      state.userapp = userapp;
    },
    userdata(state, userdata) {
      let usrdata = JSON.stringify(userdata)
      localStorage.setItem("user", usrdata);
    },
    documentationsField(state, obj) {
      state.documentField = obj
    },
    changeAppCode(state, appcode) {
      state.appCode = appcode;
    },
  }
});
